var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd591d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M46.821 28H24.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd591d",
    d: "M12.21 26.103l16.265-7.879c1.081-.523 2.396-.099 2.937.949.152.294.23.619.23.948L28.476 28l3.168 7.88c0 1.17-.98 2.12-2.189 2.12-.34 0-.675-.077-.979-.224L12.21 29.897c-1.08-.524-1.52-1.798-.978-2.845.211-.41.555-.743.978-.949z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c8c7b9d810b83d797f1b2c284952534c.svg";
export { ForwardRef as ReactComponent };